export default () => ({
  trigger: {
    name: 'quantity_selector.show',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'order_block',
      },
    },
    nonInt: true,
  },
});
